
export const statusList = [
    { label: 'Pending', value: 'PENDING' },
    { label: 'Cancelled', value: 'CANCELLED' },
    { label: 'Success', value: 'SUCCESS' },
    { label: 'Failed', value: 'FAILED' }
]
